import React from 'react';
import { LocaleService } from '@sm360/widget-commons-core-services';

import 'trade-in-360/components/TradeInValueSuccess/TradeInValueSuccess.scss';

const TradeInValueSuccess = () => {
    return (
        <div className="confirm_tradein--wrapper">
            <div className="confirm_tradein--icon">
                <icon className="icon-Crochet" />
            </div>
            <div className="confirm_tradein--content">
                <p className="confirm_tradein--title sr-text is-bold">{LocaleService.t('TRADE_IN.CONGRATS')}</p>
                <p>{LocaleService.t('TRADE_IN.GUEST_USER_SUCCESS')}</p>
            </div>
        </div>
    );
};

TradeInValueSuccess.displayName = 'TradeInValueSuccess';

export default TradeInValueSuccess;
